'use client';
import { Checkbox } from 'antd';
import { FilterCategoryProps } from 'types/ProductType';

const FilterCategory: React.FC<FilterCategoryProps> = ({
  categories,
  setFilterCategory,
  filterCategory,
  className = '',
}) => {
  const handleCheckboxChange = (checked: boolean, value: string) => {
    setFilterCategory((prev) => (checked ? [...prev, value] : prev.filter((id) => id !== value)));
  };

  return (
    <div className={'w-full space-y-4 px-6 h-[calc(100vh-400px)] min-h-[200px] rounded-lg overflow-auto ' + className}>
      <h2 className='font-bold text-base uppercase text-[#0000008F] m-0 leading-8'>Danh mục</h2>

      {categories.map((category) => {
        return (
          <div key={category.id}>
            <div className='flex items-center justify-between'>
              <Checkbox
                className='h-8 !items-center flex'
                value={category.id}
                checked={filterCategory.includes(category.id)}
                onChange={(e) => handleCheckboxChange(e.target.checked, e.target.value)}
              >
                {category.name} ({category.productCount})
              </Checkbox>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FilterCategory;
